import React, { useState, useEffect } from "react";
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, Grid } from "@mui/material";
import LogoUrlData from "../LogoUrl";
import { Loader } from "@egovernments/digit-ui-react-components";
import { ToWords } from "to-words";
import FormattedDate from "../../../components/TimeStamp";

const PaymentChallan = ({ formData, item, taxHead, totalAmount, logoUrl }) => {
  console.log("formData33333", formData, item, taxHead, totalAmount);
  const toWords = new ToWords();
  const [logoData, setLogoData] = useState(null);
  const [loading, setLoading] = useState(true); // Initially true
  const [amountDetails, setAmountDetails] = useState("");
  const authorityName = formData?.department === "DA" ? "Development Authority" : "Avas Vikas Parishad";
  const locationName = formData?.applicationType === "FORM_LANDUSE" ? formData?.location1 : formData?.locationDistrict;

  useEffect(() => {
    if (item?.estimateAmount) {
      const wordsList = toWords.convert(item?.estimateAmount, {
        currency: true,
        ignoreDecimal: false,
      });
      setAmountDetails(wordsList);
      // console.log("Amount in words:", wordsList);
    }
  }, [item?.estimateAmount]);

  return (
    <React.Fragment>
      {/* <LogoUrlData
        department={formData?.department}
        district={locationName}
        onDataFetched={(data) => {
          setLogoData(data);
          setLoading(false);
        }}
        onLoadingChange={setLoading}
      /> */}

      {
        <Box className="Paymentchallan" p={4}>
          {/* Header */}
          <Box display="flex" alignItems="center" justifyContent="center" position="relative" mb={2} border={1} borderColor="grey.800" p={2}>
            <img width={120} src={logoUrl} alt="Authority Logo" style={{ position: "absolute", left: 25, height: 60 }} />
            <Box textAlign="center">
              <Typography variant="h6">
                {locationName} {authorityName}
              </Typography>
              <Typography variant="subtitle1">Demand Note (Challan / Invoice)</Typography>
            </Box>
          </Box>

          {/* Info Section */}
          <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <strong>Challan No.:</strong> {formData?.taxHeadEstimates?.[formData?.taxHeadEstimates?.length - 1]?.challanNo}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Issue Date:</strong>
                <FormattedDate timestamp={formData?.taxHeadEstimates?.[formData?.taxHeadEstimates?.length - 1]?.challanGeneratedDateTime} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Owner Name:</strong> {formData?.landInfo?.owners?.[0]?.name || "NA"}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Application Number:</strong>
                {formData?.applicationNo}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Plot Area (Sq. Mt.):</strong> {formData?.plotArea}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Application Type:</strong> {formData?.natureOfConstruction || "NA"}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>City Name:</strong> {locationName || "NA"}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Plot Sub Use:</strong> {formData?.descriptionOfLand?.subLandUseAsPerLayout || "NA"}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Scheme Name:</strong> {formData?.descriptionOfLand?.schemeName || "NA"}
              </Grid>
              <Grid item xs={12} sm={6}>
                <strong>Plot/Khasra Number:</strong>
                {formData?.descriptionOfLand?.plotNo} /{formData?.khasraNo}
              </Grid>
              <Grid item xs={12}>
                <strong>Property address:</strong> {formData?.descriptionOfLand?.landAddress || "NA"} , Uttar Pradesh{" "}
              </Grid>
              <Grid item xs={12}>
                <strong>Owner Communication Address:</strong> {formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address || "NA"} , Uttar
                Pradesh ,{formData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno}
              </Grid>
            </Grid>
          </Paper>

          {/* Table */}
          <Table component={Paper} size="small">
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Particulars</TableCell>
                <TableCell>Area (Sq. Mt.)/Estimated Cost</TableCell>
                {formData?.planOn !== "SELF_MAP" && <TableCell>Area by Authority</TableCell>}
                <TableCell>Rate</TableCell>
                <TableCell>Total Fees</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>
            {(formData?.planOn != "FORM_MAP_COMPOUNDING") && (
              <TableBody>
                {(formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                  formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") &&
                  taxHead ? (
                  <React.Fragment>
                    {taxHead.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row?.feeType}</TableCell>
                        <TableCell>{row?.plotBuildUpArea}</TableCell>
                        <TableCell>{row?.updatedAreaJE || "-"}</TableCell>
                        <TableCell>{row?.rate}</TableCell>
                        <TableCell>{row?.amount}</TableCell>
                         <TableCell>{item?.remarks}</TableCell>
                      </TableRow>
                    ))}
                    {formData?.planOn !== "SELF_MAP" && (
                      <TableRow>
                        <TableCell>{taxHead.length + 1}</TableCell>
                        <TableCell>Fee On Plot</TableCell>
                        <TableCell>{formData?.totalBuildUpArea}</TableCell>
                        <TableCell>{formData?.totalBuildUpArea}</TableCell>
                        <TableCell>{formData?.taxHeadEstimates?.[0]?.mapRate?.unitPrice}</TableCell>
                        <TableCell>{formData?.taxHeadEstimates?.[0]?.mapRate?.price}</TableCell>
                             <TableCell>{item?.unit || "-"}</TableCell>
                         <TableCell>{item?.remarks}</TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ) : formData?.planOn === "SELF_MAP" && taxHead ? (
                  <React.Fragment>
                    {taxHead.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row?.feeType}</TableCell>
                        <TableCell>{row?.calculatedArea}</TableCell>
                        {/* <TableCell>{row?.updatedAreaJE || "-"}</TableCell> */}
                        <TableCell>{row?.rate}</TableCell>
                        <TableCell>{row?.amount}</TableCell>
                           <TableCell>{row?.unit || "-"}</TableCell>
                         <TableCell>{row?.remarks}</TableCell>
                      </TableRow>
                    ))}
                    {formData?.planOn !== "SELF_MAP" && (
                      <TableRow>
                        <TableCell>{taxHead?.length + 1}</TableCell>
                        <TableCell>Fee On Plot</TableCell>
                        <TableCell>{formData?.totalBuildUpArea}</TableCell>
                        <TableCell>{formData?.totalBuildUpArea}</TableCell>
                        <TableCell>{formData?.taxHeadEstimates?.[0]?.mapRate?.unitPrice}</TableCell>
                        <TableCell>{formData?.taxHeadEstimates?.[0]?.mapRate?.price}</TableCell>
                            <TableCell>{formData?.taxHeadEstimates?.[0]?.mapRate?.unit || "-"}</TableCell>
                         <TableCell>{formData?.taxHeadEstimates?.[0]?.mapRate?.remarks}</TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ) : Array.isArray(item?.paymentHeads) && item?.paymentHeads.length > 0 ? (
                  item.paymentHeads.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row?.feeType}</TableCell>
                      <TableCell>{row?.plotBuildUpArea}</TableCell>
                      <TableCell>{row?.updatedAreaJE}</TableCell>
                      <TableCell>{row?.rate}</TableCell>
                      <TableCell>{row?.amount}</TableCell>
                          <TableCell>{row?.unit || "-"}</TableCell>
                       <TableCell>{row?.remarks}</TableCell>
                    </TableRow>
                  ))
                ) : item?.mapRate ? (
                  <TableRow>
                    <TableCell>1</TableCell>
                    <TableCell>{item?.mapRate?.name}</TableCell>
                    <TableCell>{item?.mapRate?.area}</TableCell>
                    <TableCell>{item?.mapRate?.unitPrice}</TableCell>
                    <TableCell>{item?.mapRate?.price}</TableCell>
                        <TableCell>{item?.mapRate?.unit || "-"}</TableCell>
                     <TableCell>{item?.mapRate?.remarks}</TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No payment details available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
            {formData?.planOn === "FORM_MAP_COMPOUNDING" && (
              <TableBody>
                {formData?.compoundingHeads?.length > 0 ? (
                  formData?.compoundingHeads.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item?.feeType}</TableCell>
                      <TableCell>{item?.quantity}</TableCell>
                      <TableCell>{item?.rate}</TableCell>
                      <TableCell>{item?.factor}</TableCell>
                      <TableCell>{item?.amount}</TableCell>
                      <TableCell>{item?.unit || "-"}</TableCell>
                      <TableCell>{item?.remarks}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No payment details available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>

          <Box mt={2} display="flex" justifyContent="space-between">
            <Typography variant="body2">
              <p>
                <strong>Total Amount (In INR):</strong> ₹ {totalAmount || item?.estimateAmount || "NA"}
              </p>
              {/* {formData?.planOn !== "Self Certification of residential Plot Area upto 300 SqM on approved layouts" &&
                formData?.planOn !== "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" && (
                  <React.Fragment>
                    <p>
                      <strong>Amount (In Words):</strong> {amountDetails || "NA"}
                    </p>
                    <p>
                      <strong>Previously Paid :</strong> ₹ {formData?.taxHeadEstimates?.[0]?.estimateAmount || "NA"}
                    </p>
                  </React.Fragment>
                )} */}
            </Typography>
          </Box>

          {/* Footer Note */}
          <Box mt={2}>
            <Typography variant="body2">
              <strong>Note:</strong> Amount calculated is based on the formula followed by authority.
            </Typography>
            <Typography variant="caption">
              <em>This Document is not valid for any Bank Loan or Registration under RERA Act 2016.</em>
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body2">
              <strong>This challan is not final. Amount may be updated before final approval.</strong>
            </Typography>
          </Box>
        </Box>
      }
    </React.Fragment>
  );
};

export default PaymentChallan;
